export default {"src":"/_next/static/media/zilla.4de879fe.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};